import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useNavigate } from "react-router-dom";

type SkipModalProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
};

export const SkipModal = ({ open, setOpen }: SkipModalProps) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="[&>button]:hidden py-8 w-[360px] ring-0 ring-transparent rounded-xl">
        <DialogTitle className="dialog-content text-black text-center text-xl leading-[30px] mx-auto font-bold">
          <p>マイページでいつでも見れます！</p>
        </DialogTitle>

        <div>
          <img
            src="/assets/tutorial/tutorial-in-menu.png"
            alt="Tutorial in Menu"
            className="mx-auto mt-4"
            draggable={false}
          />
        </div>

        <div className="mt-8">
          <Button
            className="text-lg w-full py-[25px] text-white rounded-lg font-bold"
            variant="default"
            onClick={() => {
              setOpen(false);
              navigate("/prediction-market");
            }}
          >
            確認
          </Button>

          <div
            className="text-center w-full text-primary hover:opacity-70 underline cursor-pointer mt-5"
            onClick={() => setOpen(false)}
          >
            閉じる
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
